import { Add } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import moment from 'moment';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';

import Loading from '../Loading/Loader';
import {
  addPermisosGenerales,
  fetchCambiarSuccess,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
} from './../../../redux/PermisosGenerales/PermisosGeneralesSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const PermisoGeneralNuevo = ({ open, setOpen }) => {
  const isLoading = useSelector(selectIsLoading);
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm();

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = (permisoGeneral) => {
    dispatch(addPermisosGenerales(permisoGeneral));
  };

  useEffect(() => {
    const date = new Date();
    setValue('horaInicioDate', moment(new Date(date.getFullYear(), date.getMonth(), date.getDay(), 8, 0, 0, 0)).format('yyyy-MM-DD HH:mm:ss'));
    setValue('horaTerminoDate', moment(new Date(date.getFullYear(), date.getMonth(), date.getDay(), 16, 0, 0, 0)).format('yyyy-MM-DD HH:mm:ss'));
    setValue('fecha', new Date());
    setValue('descripcion', '');
  }, []);

  useEffect(() => {
    const date = new Date();
    setValue('horaInicioDate', moment(new Date(date.getFullYear(), date.getMonth(), date.getDay(), 8, 0, 0, 0)).format('yyyy-MM-DD HH:mm:ss'));
    setValue('horaTerminoDate', moment(new Date(date.getFullYear(), date.getMonth(), date.getDay(), 16, 0, 0, 0)).format('yyyy-MM-DD HH:mm:ss'));
    setValue('fecha', new Date());
    setValue('descripcion', '');
  }, [open]);

  useEffect(() => {
    if (isSuccess === 'success' && message.length > 0) {
      handleClose();
      swal('Exito!', message, 'success');
      dispatch(fetchCambiarSuccess());
    } else if (isSuccess === 'error' && message.length > 0) {
      swal('Error!', message, 'error');
    }
  }, [isSuccess]);

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
      <Box sx={{ ...style, width: 700, minHeight: 400, maxHeight: 700 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="container">
            <div className="row">
              <h3 className="text-primary-mem text-center">Nuevo Permiso General</h3>
            </div>
            <div className="row">
              <div className="col-5 me-0 pe-0">
                <hr />
              </div>
              <div className="col-2 text-center">
                <Add className="text-primary-mem" />
              </div>
              <div className="col-5 ms-0 ps-0 ">
                <hr />
              </div>
            </div>
            <div className="row mb-3">
              <div className="form-group">
                <label className="fw-bold">Descripción</label>
                <textarea
                  rows={2}
                  className="form-control"
                  {...register('descripcion', {
                    required: 'La descripción es un valor requerido',
                  })}
                  type="text"
                />
              </div>
              <p className="text-danger mt-3 mb-0">{errors.descripcion?.message}</p>
            </div>
            <div className="row mb-3">
              <div className="form-group">
                <label className="fw-bold">Fecha</label>
                <Controller
                  control={control}
                  name="ReactDatepicker"
                  {...register('fecha', {
                    required: 'La fecha es requerida',
                  })}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat="dd/MM/yyyy"
                        label={' '}
                        mask="__/__/____"
                        value={field.value}
                        onChange={(e) => field.onChange(e)}
                        renderInput={(params) => <TextField className="form-control" {...params} />}
                      />
                    </LocalizationProvider>
                  )}
                />
                <p className="text-danger mt-3 mb-0">{errors.fecha?.message}</p>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-6">
                <div className="form-group">
                  <label className="fw-bold">Hora Inicio</label>
                  <Controller
                    control={control}
                    // className="mb-3"
                    name="horaInicioDate"
                    {...register('horaInicioDate', {
                      required: 'La hora de inicio es requerida',
                    })}
                    render={({ field }) => (
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          value={field.value}
                          label={' '}
                          onChange={(e) => field.onChange(moment(e).format('yyyy-MM-DD HH:mm:ss'))}
                          renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                        />
                      </LocalizationProvider>
                    )}
                  />
                  <p className="text-danger mt-3 mb-0">{errors.horaInicioDate?.message}</p>
                </div>
              </div>
              <div className="col-6  mb-3">
                <div className="form-group">
                  <label className="fw-bold">Hora Término</label>
                  <Controller
                    control={control}
                    // className="mb-3"
                    name="horaTerminoDate"
                    {...register('horaTerminoDate', {
                      required: 'La hora de término es requerida',
                    })}
                    render={({ field }) => (
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          value={field.value}
                          label={' '}
                          onChange={(e) => field.onChange(moment(e).format('yyyy-MM-DD HH:mm:ss'))}
                          renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                        />
                      </LocalizationProvider>
                    )}
                  />
                  <p className="text-danger mt-3 mb-0">{errors.horaTerminoDate?.message}</p>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center align-self-end">
              <button className="btn btn-primary-mem me-3" id="btn-guardar">
                Guardar
              </button>
              <button id="btn-cancelar" type="button" className="btn btn-danger" onClick={handleClose}>
                Cancelar
              </button>
            </div>
          </div>
        </form>
        <Loading open={isLoading} />
      </Box>
    </Modal>
  );
};

export default PermisoGeneralNuevo;
